<script>
import { useHead } from '@unhead/vue';
import structuredData from './lib/structuredData';

export default {
  name: 'StructuredDataBreadcrumbList',
  render() {
    // Return null since this is only rendering meta data
    return null;
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    },
    sitecoreApiHost: {
      type: String,
      default: ''
    },
    partnerUrl: {
      type: String,
      default: ''
    },
    partnerDisplayName: {
      type: String,
      default: ''
    },
    parents: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const structuredDataBreadcrumbList = structuredData(props, 'breadcrumblist');

    if (!structuredDataBreadcrumbList.error) {
      useHead({
        script: [structuredDataBreadcrumbList]
      });
    } else {
      console.log(structuredDataBreadcrumbList.error);
    }
  }
};
</script>
